module.exports = __webpack_public_path__ + "img/dropify.b321d818.svg";